export default import.meta.ROLLUP_FILE_URL_U2YZxvNlcnuoWcGKwa9Wsw;